<template>
  <fab
    v-if="getFavoriteScenes.length"
    main-icon="scene-lg"
    position="bottom-right"
    :bg-color="bgColor"
    :actions="getFavoriteScenesForFAB"
    @click="invokeScene"
    :fixed-tooltip="true"
  ></fab>
</template>

<script>
import Fab from '@/components/utils/FAB.vue';
import { mapGetters } from 'vuex';
import InvokeSceneMixin from '@/components/scenes/InvokeSceneMixin';

export default {
  name: 'SceneFAB',
  mixins: [
    InvokeSceneMixin,
  ],
  data() {
    return {
      bgColor: '#778899',
    };
  },
  computed: {
    ...mapGetters([
      'getFavoriteScenes',
    ]),
    getFavoriteScenesForFAB() {
      return this.getFavoriteScenes.map(scene => ({
        name: scene.id,
        icon: scene.icon,
        tooltip: scene.name,
      }));
    },
  },
  components: {
    Fab,
  },
};
</script>

<style scoped>

</style>
